/**
 * OttoThinking — animated Otto icon used as the thinking/generating indicator
 * for Otto messages in Companion V2.
 *
 * Ported from the Claude Design handoff "Otto Thinking.html" prototype:
 * gentle head tilt with ear follow-through, subtle breathing, occasional blink,
 * three staggered indigo thought dots overlaying the head, and a soft ambient
 * glow pulsing with the thought cycle.
 */
export const OttoThinking = () => (
  <span className="otto-thinking" aria-hidden="true">
    <span className="otto-thinking__stage">
      <span className="otto-thinking__thought">
        <span className="otto-thinking__dot otto-thinking__dot--d1" />
        <span className="otto-thinking__dot otto-thinking__dot--d2" />
        <span className="otto-thinking__dot otto-thinking__dot--d3" />
      </span>
      <span className="otto-thinking__wrap">
        <svg
          className="otto-thinking__otto"
          viewBox="0 0 900 900"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
        >
          <defs>
            <clipPath id="otto-thinking-clip">
              <circle cx="450" cy="450" r="450" />
            </clipPath>
            <linearGradient
              id="otto-thinking-body"
              x1="471.686"
              y1="480.083"
              x2="440.944"
              y2="1688.01"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CFB991" />
              <stop offset="0.35" stopColor="#E0D3B4" />
              <stop offset="0.555475" stopColor="#CFB991" />
              <stop offset="1" stopColor="#CFB991" />
            </linearGradient>
            <linearGradient
              id="otto-thinking-face"
              x1="456.657"
              y1="147.647"
              x2="456.657"
              y2="708.565"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E0D3B4" />
              <stop offset="1" stopColor="#C1A876" />
            </linearGradient>
          </defs>
          <g clipPath="url(#otto-thinking-clip)">
            <circle cx="450" cy="450" r="450" fill="#E0E7FF" />
            <path
              d="M470.449 420.947C726.473 420.947 750.613 978.344 750.613 978.344C719.875 1110.64 617.466 1327.98 588.091 1493.91C582.928 1523.07 577.547 1553.47 571.893 1585.31L571.14 1589.55C570.859 1591.13 571.032 1592.8 571.601 1594.31C594.154 1654.04 589.352 1657.56 585.464 1680.79C584.7 1685.35 580.721 1688.82 575.963 1688.82L479.46 1688.96C474.959 1688.97 471.078 1685.86 470.246 1681.57C463.914 1648.82 462.398 1628.92 482.925 1585.31L483.13 1584.88C483.312 1584.49 483.496 1584.1 483.682 1583.71C484.126 1582.78 484.42 1581.76 484.527 1580.74L528.077 1162.87C528.704 1156.86 523.275 1152.08 517.264 1153.65C500.103 1158.13 476.006 1165.5 451.067 1165.5C425.611 1165.5 399.077 1157.85 381.098 1153.39C375.312 1151.95 369.985 1156.35 370.254 1162.14C376.727 1301.76 412.962 1439.17 419.413 1579.49C419.487 1581.1 420.02 1582.69 420.894 1584.06C421.165 1584.48 421.432 1584.9 421.696 1585.31C455.51 1638.65 437.974 1655.01 431.814 1680.79C430.735 1685.31 426.766 1688.81 421.99 1688.81H340.873C336.33 1688.81 332.453 1685.64 331.49 1681.33C325.782 1655.75 318.717 1643.15 332.37 1592.63C332.788 1591.08 332.802 1589.42 332.378 1587.88L331.687 1585.31L168.267 978.344C168.267 978.344 174.084 420.947 470.449 420.947Z"
              fill="url(#otto-thinking-body)"
            />
            <path
              d="M453.843 977.868C455.011 979.035 456.901 979.039 458.074 977.878L712.094 726.311C712.82 725.592 713.13 724.553 712.917 723.553L700.785 666.67C700.405 664.887 698.605 663.822 696.887 664.432C674.814 672.267 542.698 717.84 455.954 717.84C369.293 717.84 239.182 672.355 217.238 664.455C215.516 663.835 213.7 664.897 213.318 666.687L201.186 723.562C200.974 724.557 201.28 725.591 202 726.31L453.843 977.868Z"
              fill="#4338CA"
            />
            <g className="otto-thinking__head">
              <g className="otto-thinking__ear otto-thinking__ear--left">
                <path
                  d="M348.59 228.774C340.634 272.18 308.043 268.434 258.917 337.874C206.931 411.357 184.234 399.683 160.49 421.855C136.745 444.027 115.686 309.124 210.944 231.837C272.097 182.223 356.547 185.368 348.59 228.774Z"
                  fill="#C1A876"
                />
                <path
                  d="M309.211 171.432C319.731 217.685 259.2 238.045 210.074 307.485C158.089 380.968 185.019 444.256 161.274 466.428C137.529 488.6 85.3796 284.051 169.946 195.192C267.978 92.1818 298.692 125.179 309.211 171.432Z"
                  fill="#DCCEAC"
                />
              </g>
              <g className="otto-thinking__ear otto-thinking__ear--right">
                <path
                  d="M568.837 237.537C576.794 280.943 609.385 277.197 658.511 346.637C710.497 420.119 733.193 408.446 756.938 430.618C780.682 452.79 801.742 317.886 706.483 240.6C645.331 190.985 560.881 194.131 568.837 237.537Z"
                  fill="#C1A876"
                />
                <path
                  d="M608.214 180.195C597.695 226.447 658.226 246.808 707.351 316.248C759.337 389.73 732.407 453.019 756.152 475.191C779.896 497.362 832.046 292.814 747.48 203.954C649.448 100.945 618.734 133.942 608.214 180.195Z"
                  fill="#DCCEAC"
                />
              </g>
              <path
                d="M457.987 147.692C819.774 153.073 616.847 634.921 595.183 677.295C573.519 719.67 336.883 719.668 314.993 673.057C293.104 626.446 96.2007 142.311 457.987 147.692Z"
                fill="url(#otto-thinking-face)"
              />
              <path
                d="M457.499 647.816C457.499 647.816 573.285 704.538 574.043 604.729C574.589 532.814 522.337 482.079 457.337 481.585C392.336 481.092 339.202 531.027 338.656 602.942C337.936 697.815 457.499 647.816 457.499 647.816Z"
                fill="#C1A876"
              />
              <path
                d="M408.651 530.67C408.462 549.356 430.373 576.832 456.875 577.1C483.376 577.367 504.432 550.325 504.62 531.638C504.809 512.951 483.376 507.736 456.875 507.469C430.373 507.202 408.839 511.983 408.651 530.67Z"
                fill="#3D3D3D"
              />
              <g className="otto-thinking__eyes">
                <path
                  d="M518.995 419.391C517.741 437.658 536.508 420.594 558.112 422.077C579.716 423.560 595.975 443.029 597.229 424.762C598.483 406.495 581.305 400.407 559.701 398.924C538.098 397.441 520.249 401.124 518.995 419.391Z"
                  fill="#3D3D3D"
                />
                <path
                  d="M392.890 419.391C394.144 437.658 375.377 420.594 353.773 422.077C332.169 423.560 315.910 443.029 314.656 424.762C313.402 406.495 330.580 400.407 352.183 398.924C373.787 397.441 391.636 401.124 392.890 419.391Z"
                  fill="#3D3D3D"
                />
              </g>
            </g>
          </g>
        </svg>
      </span>
    </span>
    <style>{`
      .otto-thinking {
        display: inline-block;
        width: 100%;
        height: 100%;
        line-height: 0;
      }
      .otto-thinking__stage {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        container-type: inline-size;
      }
      .otto-thinking__stage::before {
        content: "";
        position: absolute;
        inset: -6%;
        border-radius: 50%;
        background: radial-gradient(circle at 50% 55%,
          rgba(99, 102, 241, 0.22) 0%,
          rgba(99, 102, 241, 0.08) 35%,
          rgba(99, 102, 241, 0) 65%);
        filter: blur(4px);
        animation: otto-thinking-ambient 2.6s ease-in-out infinite;
        z-index: 0;
        pointer-events: none;
      }
      @keyframes otto-thinking-ambient {
        0%, 100% { opacity: 0.55; transform: scale(1); }
        50%      { opacity: 1;    transform: scale(1.04); }
      }
      .otto-thinking__wrap {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        z-index: 1;
        animation: otto-thinking-breathe 3.2s ease-in-out infinite;
        transform-origin: 50% 60%;
      }
      @keyframes otto-thinking-breathe {
        0%, 100% { transform: scale(1); }
        50%      { transform: scale(1.012); }
      }
      .otto-thinking__otto {
        width: 100%;
        height: 100%;
        display: block;
        overflow: visible;
        filter: drop-shadow(0 2px 4px rgba(67, 56, 202, 0.18));
      }
      .otto-thinking__head {
        transform-box: view-box;
        transform-origin: 457px 680px;
        animation: otto-thinking-tilt 4s ease-in-out infinite;
      }
      @keyframes otto-thinking-tilt {
        0%   { transform: rotate(0deg); }
        20%  { transform: rotate(-7deg); }
        50%  { transform: rotate(0deg); }
        70%  { transform: rotate(6deg); }
        100% { transform: rotate(0deg); }
      }
      .otto-thinking__ear {
        transform-box: view-box;
        animation: otto-thinking-ear-sway 4s ease-in-out infinite;
        animation-delay: 0.12s;
      }
      .otto-thinking__ear--left  { transform-origin: 310px 290px; }
      .otto-thinking__ear--right { transform-origin: 605px 290px; }
      @keyframes otto-thinking-ear-sway {
        0%   { transform: rotate(0deg); }
        20%  { transform: rotate(-1.5deg); }
        50%  { transform: rotate(0deg); }
        70%  { transform: rotate(1.5deg); }
        100% { transform: rotate(0deg); }
      }
      .otto-thinking__eyes {
        transform-box: fill-box;
        transform-origin: 50% 50%;
        animation: otto-thinking-blink 4s ease-in-out infinite;
      }
      @keyframes otto-thinking-blink {
        0%, 46%, 50%, 96%, 100% { transform: scaleY(1); }
        48%                     { transform: scaleY(0.1); }
        98%                     { transform: scaleY(0.1); }
      }
      .otto-thinking__thought {
        position: absolute;
        top: 18%;
        left: 58%;
        display: flex;
        align-items: flex-end;
        gap: 4cqw;
        z-index: 3;
        filter: drop-shadow(0 1px 3px rgba(67, 56, 202, 0.25));
      }
      .otto-thinking__dot {
        border-radius: 50%;
        box-shadow: 0 2px 6px rgba(99, 102, 241, 0.35);
        animation: otto-thinking-dot-pop 1.4s ease-in-out infinite;
        transform-origin: center;
      }
      /* Dots scale with the stage width via container queries, so the icon
         looks right at any parent size (e.g., 40px avatar or larger). */
      .otto-thinking__dot--d1 {
        width: 6cqw; height: 6cqw;
        background: #818CF8;
        animation-delay: 0s;
      }
      .otto-thinking__dot--d2 {
        width: 10cqw; height: 10cqw;
        background: #6366F1;
        animation-delay: 0.16s;
      }
      .otto-thinking__dot--d3 {
        width: 16cqw; height: 16cqw;
        background: #4F46E5;
        animation-delay: 0.32s;
      }
      @keyframes otto-thinking-dot-pop {
        0%, 70%, 100% { transform: translateY(6%) scale(0.85); opacity: 0.35; }
        25%           { transform: translateY(-10%) scale(1.05); opacity: 1; }
        45%           { transform: translateY(0%)   scale(1);    opacity: 0.9; }
      }
      @media (prefers-reduced-motion: reduce) {
        .otto-thinking__stage::before,
        .otto-thinking__wrap,
        .otto-thinking__head,
        .otto-thinking__ear,
        .otto-thinking__eyes,
        .otto-thinking__dot { animation: none !important; }
      }
    `}</style>
  </span>
);
